import { Alert, styled } from '@mui/material';

export const AlertMessage = styled(Alert)({
  fontWeight: 600,
});
